"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Feature;
(function (Feature) {
    Feature["AccountantAccess"] = "accountantAccess";
    Feature["AutomaticVirtualCardOrder"] = "automaticVirtualCardOrder";
    Feature["BulkTransfers"] = "bulkTransfers";
    Feature["CashDeposit"] = "cashDeposit";
    Feature["CheckDeposit"] = "checkDeposit";
    Feature["CashflowManagementDashboard"] = "cashflowManagementDashboard";
    Feature["InsuranceAssistance"] = "insuranceAssistance";
    Feature["InvoicingItemsCatalog"] = "invoicingItemsCatalog";
    Feature["MultiWallet"] = "multiWallet";
    Feature["PersonalizedLogo"] = "personalizedLogo";
    Feature["TeamManagement"] = "teamManagement";
    Feature["UrssafEstimator"] = "urssafEstimator";
})(Feature || (Feature = {}));
exports.default = Feature;
